import React from 'react';
import ActionLink from '../../builder/ActionLink';
import { getRemotedbUrl } from '../../../lib/ep';

const PendingParticipations = (props) => {
	const promotion_id = props?.promotion_id ?? false;

	if(promotion_id === false) return null;

	const pending_tickets = props?.pending_tickets ?? {};

	const stages_with_pending_part = Object.keys(pending_tickets);

	if(stages_with_pending_part.length > 1) {
		return (
			<div class="pending_participations">
				More stages
			</div>
		)
	}

	return (
		<div class="pending_participations">
			{(stages_with_pending_part.length > 0) && (
				<ActionLink
					_href={getRemotedbUrl(`/promotions/participate/${promotion_id}/${stages_with_pending_part[0]}`)}
					autotranslate={false}
				>+ {pending_tickets[stages_with_pending_part[0]]}</ActionLink>
			)}
		</div>
	)
};

export default PendingParticipations;